<template>
  <div>
    <v-form>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Bilet Genel Parametreler</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn @click="Kaydet()" class="white--text" flat>Kaydet
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </v-toolbar>

          </v-flex>

<v-flex xs12 sm6 md3 pa-1 >
          <v-flex xs12 sm12 md12 >
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Genel</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>

                    <v-switch label="Muhasebe Entegre" hide-details="" v-model="BiletParametre.ParametreGenel.MuhasebeEntegre"></v-switch>
                    <v-switch label="Servis Farkını İskontoda Göster" v-model="BiletParametre.ParmetreIskonto.ServisFarkiIskontoGoster"
                      hide-details=""></v-switch>

                    <v-switch label="Fatura No Otomatik Ver" v-model="BiletParametre.ParametreGenel.FaturaNoOtomatik"
                      hide-details=""></v-switch>
                    <v-switch label="Kur Tarihi Olarak Bilet Satış Tarihini Al" hide-details="" v-model="BiletParametre.ParametreGenel.KurTarihiSatisTarihiKullan"></v-switch>
                    <v-switch label="Serbest Faturada Döviz Satış Kuru Kullan" hide-details="" v-model="BiletParametre.ParametreGenel.SerbestFaturaDovizSatisKuru"></v-switch>
                    <v-switch label="Fatura Boyutlarını Parametreden Al" hide-details="" v-model="BiletParametre.ParametreGenel.FaturaBoyutParametre"></v-switch>
                    <v-switch label="Kısa Faturalar İçin Dizayn" hide-details="" v-model="BiletParametre.ParametreGenel.KisaFaturaDizayn"></v-switch>

                    <v-switch label="İade Olmuş Biletler Faturalanmasın" hide-details="" v-model="BiletParametre.ParametreGenel.IadeBiletFaturala"></v-switch>
                    <v-switch label="Faturalanmış Biletlerde Değişikliğe İzin Verme" hide-details="" v-model="BiletParametre.ParametreGenel.FaturalanmisDegisklikYok"></v-switch>
                    <v-switch label="Havayolu Hesapların Şirkete Göre Ayır" hide-details="" v-model="BiletParametre.ParametreGenel.HavaYoluHesapSirketeGore"></v-switch>
                    <v-switch label="HY Tutarı Girildiğinde Servisi Sıfırlama" hide-details="" v-model="BiletParametre.ParametreGenel.HyTutarServisSifirlama"></v-switch>

                    <v-switch label="Yeni Versiyonu Kontrol Etme" hide-details="" v-model="BiletParametre.ParametreDiger.YeniVersiyonKontrolYok"></v-switch>
                    <v-switch label="Bolüm Kodu Zorunlu" hide-details="" v-model="BiletParametre.ParametreDiger.BolumKoduZorunlu"></v-switch>
                    <v-switch label="Tek Satır Faturada Adet Yaz" hide-details="" v-model="BiletParametre.ParametreDiger.TekSatirFaturaAdet"></v-switch>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>


          <v-flex xs12 sm12 md12 >
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>
                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Vade</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch label="Ödeme Vadesinden Tatil Günü Düşme" hide-details="" v-model="BiletParametre.ParametreVade.OdemeVadeTatilGunu"></v-switch>
                    <v-switch label="İade Vadesinden İade Tarihini Kullan" hide-details="" v-model="BiletParametre.ParametreVade.IadeVadeIadeTarihiKullan"></v-switch>
                    <v-switch label="İade Vadesi Hesapla" v-model="BiletParametre.ParametreVade.IadeVadeHesapla"
                      hide-details="">
                    </v-switch>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>
</v-flex>

          <v-flex xs12 sm6 md3 pa-1>
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Cari</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch label="Hyolu Alacağına Kom. Düşülme. Tutar İşle " hide-details="" v-model="BiletParametre.ParametreCari.HavayoluKomisyonDusulememisTutar"></v-switch>
                    <v-switch label="Bağlantılı Biletlere Cari Hareket Oluştur" hide-details="" v-model="BiletParametre.ParametreCari.BaglantiliBiletCariHareketOlustur"></v-switch>

                    <v-switch label="Peşin Biletlerde Bakiyeyi Sıfırlama" v-model="BiletParametre.ParametreCari.PesinBiletBakiyeSifir"
                      hide-details=""></v-switch>
                    <v-switch label="İskontoyu Cari Hesaba Atma" v-model="BiletParametre.ParametreCari.IskontoCariyeAtma"
                      hide-details=""></v-switch>
                    <v-switch label="Hava Yolu Carisi İçin Kesim Tarihi Kullan" hide-details="" v-model="BiletParametre.ParametreCari.HavayoluCariKesimTarih"></v-switch>
                    <v-switch label="Cariye Bilet Tutarını Ser. Tutarı  Kaydet" hide-details="" v-model="BiletParametre.ParametreCari.BiletTutariServisli"></v-switch>
                    <v-switch label="Cariye Bilet Tutarını Değişken Tutarı  Kaydet" hide-details="" v-model="BiletParametre.ParametreCari.BiletTutariDegiskenli"></v-switch>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">KDV</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch label="Faturada KDV'yi Ayır " hide-details="" v-model="BiletParametre.ParametreKdv.FaturaKdvAyir"></v-switch>
                    <v-switch label="Dekontta KDV'yi Ayır" hide-details="" v-model="BiletParametre.ParametreKdv.DekontKdvAyir"></v-switch>
                    <v-switch label="PTA Tutarında KDV'yi Ayır" v-model="BiletParametre.ParametreKdv.PtaTutarKdvAyir"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Tutarları KDV Büyük Olarak Yuvarla" v-model="BiletParametre.ParametreKdv.KdvYukariYuvarla"
                      hide-details="">
                    </v-switch>
                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Kredi Kartı</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch label="Kredi K.lı Biletlerde Tah. İskontosuz Tut. " hide-details="" v-model="BiletParametre.ParametreKrediKart.BiletTahsilatIskontosuz"></v-switch>
                    <v-switch label="Kredi K.lı Biletlerde Hyolu B/A Kapat" hide-details="" v-model="BiletParametre.ParametreKrediKart.HavayoluBorcAlacakKapat"></v-switch>
                    <v-switch label="Taksitli Satışlarda Top. Tutarı Kont. Etme" v-model="BiletParametre.ParametreKrediKart.TaksitToplamTutarKonrtrolEtme"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Kredi Kartlı Satışlarda POS KODU Zorunlu" v-model="BiletParametre.ParametreKrediKart.PosKoduZorunlu"
                      hide-details="">
                    </v-switch>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>


 <v-flex xs12 sm6 md3>
          <v-flex xs12 sm12 md12 pa-1>
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">İskonto</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch label="İskonto Hesabı Net " hide-details="" v-model="BiletParametre.ParmetreIskonto.IskontoNet"></v-switch>
                    <v-switch label="İskontoyo Üste Yuvarla" hide-details="" v-model="BiletParametre.ParmetreIskonto.IskontoYukariYuvarla"></v-switch>
                    <v-switch label="Kredi Kartlı Biletlerde İskonto Yapma" v-model="BiletParametre.ParmetreIskonto.KrediKartliBiletIskontoYok"
                      hide-details=""></v-switch>
                    <v-switch label="İç Hatlarda İskonto Yapma" v-model="BiletParametre.ParmetreIskonto.IcHatIskontoYok"
                      hide-details=""></v-switch>
                    <v-switch label="Dış Hatlarda İskonto Yapma" v-model="BiletParametre.ParmetreIskonto.DisHatIskontoYok"
                      hide-details=""></v-switch>
                    <v-switch label="İskontoyu Servis Ücretinden Hesapla" hide-details="" v-model="BiletParametre.ParmetreIskonto.IskontoServisden"></v-switch>
                    <v-switch label="Komisyonsuz Biletlerde İskonto Yapma" hide-details="" v-model="BiletParametre.ParmetreIskonto.KomisyonsuzBiletIskontoYok"></v-switch>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>




          <v-flex xs12 sm12 md12 pa-1>
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Entegerasyon Lisans</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch label="Logo Entegrasyonu " hide-details=""></v-switch>
                    <v-switch label="Netsis Entegrasyonu" hide-details=""></v-switch>
                    <v-switch label="Mikro Entegrasyonu" hide-details=""></v-switch>
                    <v-switch label="Eta Entegrasyonu" hide-details=""></v-switch>
                    <v-switch label="Luka Entegrasyonu" hide-details=""></v-switch>
                    <v-switch label="Zirve Entegrasyonu" hide-details=""></v-switch>
                    <v-switch label="Diğer Entegrasyon" hide-details=""></v-switch>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>
 </v-flex>

          <v-flex xs12 sm6 md3 pa-1>
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>
                  <v-layout justify-space-between column>

                    <v-flex xs12 sm12 md12>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Diğer</span>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-switch label="Ayrıntılı T.C. Kimlik No Kullan" v-model="BiletParametre.ParametreDiger.AyrintiliTCKimlikKullan"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Ekstra Bilet Açıklaması Kullan" v-model="BiletParametre.ParametreDiger.ExtraBiletAciklamaKullan"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Faturada Tek Havayolu Bas" v-model="BiletParametre.ParametreDiger.FaturaTekHavayolu"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Masraf Merkezi Zorunlu" v-model="BiletParametre.ParametreDiger.MasrafZorunlu"
                      hide-details="">
                    </v-switch>
                    <v-switch label="MB'sından Kurları Getirme" v-model="BiletParametre.ParametreDiger.MerkezBankasiKurYok"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Özel Firma Rapolarlama Kullanılacak" v-model="BiletParametre.ParametreDiger.OzelFirmaRaporlamaKullan"
                      hide-details="">
                    </v-switch>


                    <v-switch label="Yolcu CRM Kullan" hide-details="" v-model="BiletParametre.ParametreDiger.YolcuCrmKullan"></v-switch>
                    <v-switch label="MP Çalışma Yeri" hide-details="" v-model="BiletParametre.ParametreDiger.MpCalismaYeri"></v-switch>
                    <v-switch label="Bilet Ayrıntı" v-model="BiletParametre.ParametreDiger.BiletAyrinti" hide-details="">
                    </v-switch>
                    <v-switch label="Kredi Bilgileri" hide-details="" v-model="BiletParametre.ParametreDiger.KrediBilgileri"></v-switch>
                    <v-switch label="Taksit Kullan" hide-details="" v-model="BiletParametre.ParametreDiger.TaksitKullan"></v-switch>
                    <v-switch label="Otomatik Fatura Kullan" v-model="BiletParametre.ParametreDiger.OtomatikFaturaKullan"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Faturada Seri Girilmesi Zorunlu" v-model="BiletParametre.ParametreDiger.FaturaSeriZorunlu"
                      hide-details="">
                    </v-switch>
                    <v-switch label="Kesen Kişi Tanımlı mı? Kontrol Et" hide-details="">
                    </v-switch>
                    <v-btn flat="" color="info" @click="dialog = true" dark>Ekstra Parametreler
                      <v-icon right dark>add</v-icon>
                    </v-btn>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

        </v-layout>

      </v-card>
    </v-form>

    <v-dialog v-model="dialog" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-5">
        <v-card-title>Filtre Seçimi</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.UlkeKod" label="Ülke Kodu">
              </v-text-field>
              <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonSiparisNo" label="Son Sipariş No">
              </v-text-field>
              <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonDekontNo" label="Son Dekont No">
              </v-text-field>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonFaturaSeri" label="Son Fatura Seri">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonFaturaNo" label=" No">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonProformaSeri" label="Son Proforma Seri">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonProformaNo" label=" No">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEFaturaSeri" label="Son E-Fatura Seri">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEFaturaNo" label=" No">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEArsivNormalSeri"
                  label="Son E-Arşiv Seri (NS) ">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEArsivNormalNo" label="No">
                </v-text-field>
              </v-layout>
              <v-layout>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEarsivInternetSeri"
                  label="Son E-Arşiv Seri (IS)">
                </v-text-field>
                <v-text-field hide-details="" v-model="BiletParametre.ParametreSonFaturaBilgi.SonEArsivInternetNo"
                  label="No">
                </v-text-field>
              </v-layout>
            </div>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog=false">Tamam</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',

        BiletParametre: {
          ParametreGenel: {
            CharterKullaniyor: false,
            MuhasebeEntegre: false,
            MuhasebeSirket: null,
            HavayoluOlarakKullan: false,
            FaturaNoOtomatik: false,
            KisaFaturaDizayn: false,
            KurTarihiSatisTarihiKullan: false,
            SerbestFaturaDovizSatisKuru: false,
            FaturaBoyutParametre: false,
            BiletAlisFiyatKullan: false,
            BspTutarlariYuvarla: false,
            BspYuvarlaTaxaEkle: false,
            IadeBiletFaturala: false,
            FaturalanmisDegisklikYok: false,
            HavaYoluHesapSirketeGore: false,
            HyTutarServisSifirlama: false,
            CariAramaBos: false,
            FaturaOnayYok: false,
            DigerServisKontrol: false
          },
          ParametreCari: {
            HavayoluKomisyonDusulememisTutar: false,
            BaglantiliBiletCariHareketOlustur: false,
            CariHesapOtomatik: false,
            PesinBiletBakiyeSifir: false,
            IskontoCariyeAtma: false,
            HavayoluCariKesimTarih: false,
            BiletTutariServisli: false,
            BiletTutariDegiskenli: false,
            FaturaliBiletCariDegis: false,
            DekontServisAyri: false
          },
          ParametreKdv: {
            FaturaKdvAyir: false,
            DekontKdvAyir: false,
            PtaTutarKdvAyir: false,
            KdvYukariYuvarla: false

          },
          ParametreKrediKart: {
            BiletTahsilatIskontosuz: false,
            HavayoluBorcAlacakKapat: false,
            TaksitToplamTutarKonrtrolEtme: false,
            PosKoduZorunlu: false
          },
          ParametreVade: {
            OdemeVadeTatilGunu: false,
            IadeVadeIadeTarihiKullan: false,
            IadeVadeHesapla: false
          },
          ParmetreIskonto: {
            ServisFarkiIskontoGoster: false,
            IskontoNet: false,
            IskontoYukariYuvarla: false,
            KrediKartliBiletIskontoYok: false,
            IcHatIskontoYok: false,
            DisHatIskontoYok: false,
            IskontoServisden: false,
            KomisyonsuzBiletIskontoYok: false
          },
          ParametreDiger: {
            SeturMuhasebeKontrol: false,
            AnalizKoduKullan: false,
            AyrintiliTCKimlikKullan: false,
            ExtraBiletAciklamaKullan: false,
            FaturaTekHavayolu: false,
            MasrafZorunlu: false,
            MerkezBankasiKurYok: false,
            OzelFirmaRaporlamaKullan: false,
            BiletDetayAnaEkran: false,
            FaturaSeriZorunlu: false,
            YolcuCrmKullan: false,
            MpCalismaYeri: false,
            BiletAyrinti: false,
            KrediBilgileri: false,
            FaturaMailKullan: false,
            TaksitKullan: false,
            OtomatikFaturaKullan: false,
            YeniVersiyonKontrolYok: false,
            BolumKoduZorunlu: false,
            TekSatirFaturaAdet: false,
            FaturaMasrafZorunlu: false,
            ServisOtomatik: false,
            ServisIcHatKodGetir: false,
          },
          ParametreSonFaturaBilgi: {
            UlkeKod: null,
            SonSiparisNo: null,
            SonDekontNo: null,
            SonFaturaSeri: null,
            SonFaturaNo: null,
            SonProformaSeri: null,
            SonProformaNo: null,
            SonEFaturaSeri: null,
            SonEFaturaNo: null,
            SonEArsivNormalSeri: null,
            SonEArsivNormalNo: null,
            SonEarsivInternetSeri: null,
            SonEArsivInternetNo: null
          }
        },
        tumparametreler: [],
        dialog: false,



        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000
      }
    },
    beforeMount: beforeMount,

    methods: {
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {
          console.log('')
        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },
      onChange: onChange,
      getDateNow: getDateNow,
      toDateformat: toDateformat,
      Kaydet: Kaydet
    },
  }

  function Kaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      GenelParametre: this.BiletParametre,
      RaporParametre: this.tumparametreler.RaporParametre,
      FirmaParametre: this.tumparametreler.FirmaParametre,
      SirketKodu: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.text1 = response.body.ResponseMessage
      this.snackbar = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }



  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreGet', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.tumparametreler = response.body
      this.BiletParametre = response.body.GenelParametre


    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true

      }
    })
  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      this.date = b
    } else {
      this.dateFormatted = null
    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '-' + mm + '-' + yyyy
    return today
  }
</script>
<style>
</style>